class WindowDimensions {

  public safeAreaTop: number;
  public safeAreaBottom: number;

  constructor() {
    this.safeAreaTop = 0;
    this.safeAreaBottom = 0;
  }

  // Set safe area values (from mobile app or dynamic sources)
  setSafeArea(top: number, bottom: number) {
    this.safeAreaTop = top;
    this.safeAreaBottom = bottom;
  }

  // Override innerHeight to handle safe area logic
  get innerHeight() {
    return window.innerHeight - this.safeAreaTop - this.safeAreaBottom
  }

  get innerWidth() {
    return window.innerWidth;
  }

}

// Create a proxy around the WindowManager instance
const windowDimensions = new WindowDimensions();

export { windowDimensions };

